
/*
:dataset-id-key="datasetIdKey"
:plugins="plugins"
:css-classes="cssClasses"
:styles="styles"
:width="width"
:height="height"
*/
// https://www.chartjs.org/docs/latest/ - documentation

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'
import { Line as LineChaart } from 'vue-chartjs'
// import * as chartConfig from './chartConfig.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

export default {
  name: 'LineChart',
  components: {
    LineChaart
  },
  props: {
    datasets: {
      type: Array,
      default: () => [[]]
    },
    labels: {
      type: Array,
      default: () => [[]]
    }
  },
  data () {
    return {
      width: null,
      height: null,
      gradientRead: null,
      gradientSpoken: null,
      gradientWritten: null,
      gradientListened: null,
      chartObj: null,
      gradientFunctions: [],
      isWaitingToResize: false,
      data: {
        labels: [],
        datasets: [{
          label: 'Read',
          // backgroundColor: 'red',
          borderColor: this.updateBorderColorRead,
          /* borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: '#42b883',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: '#42b883',
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4, */
          // radius: 2,
          data: [],
          backgroundColor: this.updateBorderColorRead
          // fill: true
        },
        {
          label: 'Written',
          // backgroundColor: 'red',
          borderColor: this.updateBorderColorWritten,
          /* borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: '#42b883',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: '#42b883',
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4, */
          // radius: 2,
          data: [],
          backgroundColor: this.updateBorderColorWritten
          // fill: true
        },
        {
          label: 'Spoken',
          // backgroundColor: 'red',
          borderColor: this.updateBorderColorSpoken,
          /* borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: '#42b883',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: '#42b883',
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4, */
          // radius: 2,
          data: [],
          backgroundColor: this.updateBorderColorSpoken
          // fill: true
        },
        {
          label: 'Listened',
          // backgroundColor: 'red',
          borderColor: this.updateBorderColorListened,
          /* borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: '#42b883',
          pointBorderColor: 'rgba(255,255,255,0)',
          pointHoverBackgroundColor: '#42b883',
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4, */
          // radius: 2,
          data: [],
          backgroundColor: this.updateBorderColorListened
          // fill: true
        }]
      },
      options: {
        // maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false
            }
          },
          y: {
            grid: {
              display: false
            },
            /* ticks: {
              beginAtZero: true
            } */
            min: 0,
            suggestedMax: 1000
          }
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom'
          }
        },
        responsive: true,
        /* tooltips: {
          // backgroundColor: '#f5f5f5',
          titleFontColor: '#333',
          bodyFontColor: '#666',
          bodySpacing: 4,
          xPadding: 12,
          mode: 'nearest',
          intersect: false,
          position: 'nearest'
        }, */
        interaction: {
          intersect: false
        },
        elements: {
          line: {
            tension: 0.4
          }
        },
        aspectRatio: 'auto'
        /* scales: {
          yAxes: [{
            barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(29,140,248,0.0)',
              zeroLineColor: 'transparent'
            },
            ticks: {
              suggestedMin: 60,
              suggestedMax: 125,
              padding: 20,
              fontColor: '#9a9a9a'
            }
          }],

          xAxes: [{
            barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(225,78,202,0.1)',
              zeroLineColor: 'transparent'
            },
            ticks: {
              padding: 20,
              fontColor: '#9a9a9a'
            }
          }]
        } */
      }
    }
  },
  mounted () {
    this.gradientFunctions = [
      this.updateBorderColorRead,
      this.updateBorderColorWritten,
      this.updateBorderColorSpoken,
      this.updateBorderColorListened
    ]
    this.$watch('datasets', (newVal, oldVal) => {
      this.data.datasets[0].data = this.datasets[0]
      if (this.chartObj) {
        this.chartObj.data.datasets = []
        // this.chartObj.data.datasets[0].data =
        this.datasets.forEach((dataset, idx) => {
          this.chartObj.data.datasets.push({
            label: dataset.label,
            // backgroundColor: 'red',
            borderColor: this.gradientFunctions[idx],
            /* borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: '#42b883',
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: '#42b883',
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4, */
            // radius: 2,
            data: dataset.data,
            backgroundColor: this.gradientFunctions[idx]
            // fill: true
          })
        })
        this.chartObj.update()
        window.onresize = this.askToReDrawChart
        // window.chartObj = this.chartObj
      }
    })
    this.$watch('labels', (newVal, oldVal) => {
      this.data.labels = this.labels[0]
      if (this.chartObj) {
        this.chartObj.data.labels = this.labels[0]
        this.chartObj.update()
      }
    })
  },
  methods: {
    askToReDrawChart () {
      if (this.chartObj && !this.isWaitingToResize) {
        this.isWaitingToResize = true
        setTimeout(this.reDrawChart, 500)
        /* this.chartObj.resize()
        console.log('chartObj.resize()') */
      }
    },
    reDrawChart () {
      this.isWaitingToResize = false
      this.chartObj.resize()
    },
    getGradient (ctx, chartArea, color, gradient) {
      const chartWidth = chartArea.right - chartArea.left
      const chartHeight = chartArea.bottom - chartArea.top
      if (!gradient || this.width !== chartWidth || this.height !== chartHeight) {
        // Create the gradient because this is either the first render
        // or the size of the chart has changed
        this.width = chartWidth
        this.height = chartHeight
        gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top)
        gradient.addColorStop(0, color[0])
        gradient.addColorStop(0.5, color[1])
        gradient.addColorStop(1, color[2])
      }

      return gradient
    },
    updateBorderColorRead (context) {
      if (!this.chartObj) {
        this.chartObj = context.chart
      }
      const chart = context.chart
      const { ctx, chartArea } = chart

      if (!chartArea) {
        // This case happens on initial chart load
        return
      }
      return this.getGradient(ctx, chartArea, ['rgba(240,140,0,0.1)', 'rgba(240,140,0,0.5)', 'rgba(240,140,0,1)'], this.gradientRead)
      // return this.getGradient(ctx, chartArea, ['red', 'red', 'red'])
    },
    updateBorderColorSpoken (context) {
      const chart = context.chart
      const { ctx, chartArea } = chart

      if (!chartArea) {
        // This case happens on initial chart load
        return
      }
      return this.getGradient(ctx, chartArea, ['rgba(1,70,60,0.1)', 'rgba(1,70,60,0.5)', 'rgba(1,70,60,1)'], this.gradientSpoken)
    },
    updateBorderColorListened (context) {
      const chart = context.chart
      const { ctx, chartArea } = chart

      if (!chartArea) {
        // This case happens on initial chart load
        return
      }
      return this.getGradient(ctx, chartArea, ['rgba(60,140,248,0.1)', 'rgba(60,140,248,0.5)', 'rgba(60,140,248,1)'], this.gradientListened)
    },
    updateBorderColorWritten (context) {
      const chart = context.chart
      const { ctx, chartArea } = chart

      if (!chartArea) {
        // This case happens on initial chart load
        return
      }
      return this.getGradient(ctx, chartArea, ['rgba(200,70,248,0.1)', 'rgba(200,70,248,0.5)', 'rgba(200,70,248,1)'], this.gradientWritten)
    }
  }
}
/*
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import { Line } from 'vue-chartjs'

export default {
  name: 'line-chart',
  extends: Line,
  // mixins: [mixins.reactiveProp],
  props: {
    extraOptions: Object,
    gradientColors: {
      type: Array,
      default: () => ['rgba(72,72,176,0.2)', 'rgba(72,72,176,0.0)', 'rgba(119,52,169,0)'],
      validator: val => {
        return val.length > 2
      }
    },
    gradientStops: {
      type: Array,
      default: () => [1, 0.4, 0],
      validator: val => {
        return val.length > 2
      }
    }
  },
  data () {
    return {
      ctx: null,
      data: {
        labels: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July'
        ],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [40, 39, 10, 40, 39, 80, 40]
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },

  mounted () {
    // this.$watch('chartData', this.chartDataChanged)
  },

  chartDataChanged (newVal, oldVal) {
    console.log('oldVal: ')
    console.dir(oldVal)
    console.log('newVal: ')
    console.dir(newVal)
    console.log('chartDataChanged')
    this.updateGradients(this.chartData)
    if (!oldVal) {
      this.renderChart(
        this.chartData,
        this.extraOptions
      )
    }
  },

  updateGradients (chartData) {
    if (!chartData) return
    const ctx = this.ctx || document.getElementById(this.chartId).getContext('2d')
    const gradientStroke = ctx.createLinearGradient(0, 230, 0, 50)

    gradientStroke.addColorStop(this.gradientStops[0], this.gradientColors[0])
    gradientStroke.addColorStop(this.gradientStops[1], this.gradientColors[1])
    gradientStroke.addColorStop(this.gradientStops[2], this.gradientColors[2])
    chartData.datasets.forEach(set => {
      set.backgroundColor = gradientStroke
    })
  }
} */
